//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, email } from 'vuelidate/lib/validators'
import { isFailure, isSuccess } from '../../utils/result-pattern'

export default {
  name: 'LoginForm',
  props: {
    isInline: {
      type: Boolean,
      default: true
    },
    isClientLogin: {
      type: Boolean,
      default: false
    },
    isFullWidth: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    isShowCart: {
      type: Boolean,
      default: false
    },
    loginAndCheckout: {
      type: Boolean,
      default: false
    },
    clientSlugs: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      latestArticle: null,
      login: {
        email: null,
        password: null
      },
      error: null,
      loading: false,
      submitted: false,
      success: false,
      availableClients: [],
      selectedClientId: null
    }
  },
  validations: {
    login: {
      email: { required, email },
      password: { required }
    }
  },
  computed: {
    cartItems() {
      return this.$store.get('cart/items') || null
    },
    cartTotal() {
      return this.cartItems.map((x) => x.quantity).reduce((a, b) => a + b, 0)
    },
    account() {
      return this.$store.get('user/user') || null
    },
    language() {
      return this.$store.get('language/locale') || 'en'
    }
  },
  async mounted() {
    this.loading = true
    this.clear()

    if (this.account && this.isClientLogin) {
      await this.getAvailableClient()
      if (this.availableClients.length === 1) {
        this.$router.replace({
          path: this.language === 'en' ? this.availableClients[0].slug : '/nld' + this.availableClients[0].slug
        })
        this.availableClients = null
        return
      }
    }

    this.loading = false
  },
  methods: {
    async onLoginSubmit() {
      this.submitted = true

      this.$v.login.$touch()
      if (this.$v.login.$invalid) {
        this.$nextTick(() => {
          const el = document.querySelector('#login-form input.is-danger')
          if (el) el.focus()
        })
        return false
      }

      this.loading = true
      this.error = null

      const result = await this.$auth.password(this.login.email, this.login.password)
      if (isFailure(result)) {
        this.error = result.value.error_description || result.value.error || 'Login failed'
        this.loading = false
        return
      }

      try {
        // get user info after successful login and emit auth change event
        const userinfo = await this.$auth.me()
        if (isSuccess(userinfo)) {
          if (typeof window !== 'undefined' && window.$nuxt) {
            window.$nuxt.$emit('on-auth-change', true)
          }
        }

        if (this.isClientLogin && this.clientSlugs) {
          await this.getAvailableClient()
          if (this.availableClients.length === 1) {
            this.$router.replace({
              path: this.language === 'en' ? this.availableClients[0].slug : '/nld' + this.availableClients[0].slug
            })
            this.availableClients = null
          } else {
            this.clear()
          }
        }

        this.$emit('userLoggedIn')
      } catch (error) {
        this.error = error.message || 'Failed to get user information'
      } finally {
        this.loading = false
      }
    },
    async getAvailableClient() {
      const response = await this.$axios.$get(`/client/GetUsersClients`)
      this.availableClients = response
        .filter((x) => this.clientSlugs.map((y) => y.clientId).includes(x.idCompany))
        .map((x) => ({
          clientId: x.idCompany,
          name: x.name,
          slug: this.clientSlugs.filter((y) => y.clientId === x.idCompany)[0].slug
        }))
    },
    onProviderSignIn(provider) {
      try {
        this.loading = true
        this.error = null

        if (provider === 'google') {
          const result = this.$auth.google()
          if (isFailure(result)) {
            this.error = result.value || 'Google authentication failed'
          }
          // note: google() performs redirect, so this code won't execute on success
        } else if (provider === 'linkedin') {
          const result = this.$auth.linkedin()
          if (isFailure(result)) {
            this.error = result.value || 'LinkedIn authentication failed'
          }
          // note: linkedin() performs redirect, so this code won't execute on success
        }
      } catch (error) {
        this.error = error.message || 'Authentication failed'
      } finally {
        this.loading = false
      }
    },
    onSelectClient() {
      const selectedClient = this.availableClients.find((x) => x.clientId === this.selectedClientId)
      if (!selectedClient) {
        return
      }
      const slug = selectedClient.slug
      this.$router.replace({ path: this.language === 'en' ? slug : '/nld' + slug })
    },
    clear() {
      this.login = {
        email: null,
        password: null
      }
      this.error = null
      this.loading = false
      this.submitted = false
      this.success = false
    },
    onOpenCart() {
      this.$emit('close')
      this.openCart(true)
    }
  }
}
